import React from 'react';
import { Chip, Grid } from '@mui/material';
import { GridColDef } from '@mui/x-data-grid';
import PageHeader from '../../../components/page-header';
import { FilterPanel } from '../../../components/filter-panel';
import { usePagedList } from '../../../hooks/use-paged-list';
import { useAuditSearchController } from './context/audit-search-controller';
import { useAuditSearchState } from './context/audit-search-context';
import AuditAppService from '../../../application/platform/apm/audit/audit-app-service';
import { ORGAO_FISCALIZADOR_LABEL, OrgaoFiscalizador, SITUACAO_AUDITORIA_LABEL, SituacaoAuditoria, enumOptions } from '../../../model/apm/apm-enums';
import { FilterInput, FilterSelect } from '../../../components/filter-fields';
import { PagedGrid } from '../../../components/paged-grid';
import { DeleteAction, EditAction, OpenLinkAction } from '../../../components/row-actions';
import { AuditDrawer } from './components/audit-drawer';
import { AUDIT_STATUS_COLOR } from './components/audit-status';

export function AuditSearchComponent() {
    const ctrl = useAuditSearchController();
    const { parameters, searchTrigger, drawer } = useAuditSearchState();
    const list = usePagedList(AuditAppService.list, parameters, searchTrigger, 'Não foi possível carregar as auditorias');

    const columns: GridColDef[] = [
        { field: 'id', headerName: 'ID', width: 80 },
        { field: 'year', headerName: 'Exercício', width: 100 },
        { field: 'inspectionBody', headerName: 'Órgão', width: 90, valueFormatter: (params) => ORGAO_FISCALIZADOR_LABEL[params.value as OrgaoFiscalizador] || '' },
        { field: 'processNumber', headerName: 'Processo', width: 170 },
        { field: 'originProcessNumber', headerName: 'Processo de origem', width: 170 },
        { field: 'unitName', headerName: 'Unidade', flex: 1, minWidth: 220 },
        {
            field: 'status', headerName: 'Situação', width: 120,
            renderCell: (params) => (
                <Chip size="small" color={AUDIT_STATUS_COLOR[params.value as SituacaoAuditoria] || 'default'} label={SITUACAO_AUDITORIA_LABEL[params.value as SituacaoAuditoria] || '-'} />
            )
        },
        {
            field: 'actions', headerName: 'Ações', width: 130, sortable: false,
            renderCell: (params) => (
                <React.Fragment>
                    {params.row.url && <OpenLinkAction url={params.row.url} title="Abrir link do processo" />}
                    <EditAction onClick={() => ctrl.openDrawer(params.row)} />
                    <DeleteAction onClick={() => ctrl.handleDelete(params.row)} />
                </React.Fragment>
            )
        }
    ];

    return (
        <React.Fragment>
            <Grid item xs={12}>
                <PageHeader
                    title="Auditorias"
                    subtitle="Processos de prestação de contas junto aos órgãos fiscalizadores"
                    breadcrumbs={[{ label: 'Auditorias' }]}
                />
            </Grid>
            <Grid item xs={12}>
                <FilterPanel onClear={ctrl.handleClearFilters} onSearch={ctrl.handleSearch}>
                    <Grid item xs={12} md={6}>
                        <FilterInput label="Unidade ou processo" name="input-term" value={parameters.term} onChange={ctrl.handleOnChange} onSearch={ctrl.handleSearch} />
                    </Grid>
                    <Grid item xs={12} sm={4} md={2}>
                        <FilterInput label="Exercício" name="input-year" type="number" value={parameters.year} onChange={ctrl.handleOnChange} onSearch={ctrl.handleSearch} />
                    </Grid>
                    <Grid item xs={12} sm={4} md={2}>
                        <FilterSelect label="Órgão" name="select-inspection-body" value={parameters.inspectionBody} options={enumOptions(ORGAO_FISCALIZADOR_LABEL)} onChange={ctrl.handleOnChange} />
                    </Grid>
                    <Grid item xs={12} sm={4} md={2}>
                        <FilterSelect label="Situação" name="select-status" value={parameters.status} options={enumOptions(SITUACAO_AUDITORIA_LABEL)} emptyLabel="Todas" onChange={ctrl.handleOnChange} />
                    </Grid>
                </FilterPanel>
            </Grid>
            <Grid item xs={12}>
                <PagedGrid
                    columns={columns}
                    list={list}
                    parameters={parameters}
                    onPaginationChange={ctrl.handlePaginationChange}
                    addLabel="Nova Auditoria"
                    onAdd={() => ctrl.openDrawer()}
                />
            </Grid>

            <AuditDrawer
                open={drawer.open}
                initial={drawer.audit}
                isSaving={ctrl.isSaving}
                onClose={ctrl.closeDrawer}
                onSave={ctrl.handleSave}
            />
        </React.Fragment>
    );
}
